import * as t from '../../actionTypes';

const initialState = {
  loading: false,
  accessCode: '',
  accessCodeSuccessfullyRedeemed: false,
  valid: null,
  error: {
    errorOccurred: false,
    errorMessage: '',
    errorCode: {
      code: ''
    }
  }
};

export default function redeemActivationCode(state = initialState, action) {
  switch (action.type) {
    /* Redeem actions */

    case t.REDEEM_ACCESS_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        accessCodeSuccessfullyRedeemed: true
      };

    case t.REDEEM_ACCESS_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        accessCodeSuccessfullyRedeemed: false,
        valid: false,
        error: {
          errorOccurred: true,
          errorMessage: action.data?.error?.message || 'An unknown error occurred',
          errorCode: {
            code: action.data?.error?.code
          }
        }
      };

    /* Validation actions */
    case t.VALIDATE_ACCCESS_CODE_FAILURE:
      return {
        ...state,
        loading: false,
        valid: false,
        error: {
          errorOccurred: true,
          errorMessage: action.data?.error?.message || 'An unknown error occurred',
          errorCode: {
            code: action.data?.error?.code
          }
        }
      };

    case t.VALIDATE_ACCCESS_CODE_SUCCESS:
      return {
        ...state,
        loading: false,
        valid: true,
        error: {
          errorOccurred: false,
          errorMessage: '',
          errorCode: {
            code: ''
          }
        }
      };

    case t.REDEEM_ACCESS_CODE_RESET:
      return {
        ...initialState
      };

    default:
      return state;
  }
}
